<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :append-to-body="true"
    :show-close="false"
    @close="dialogClose"
  >
    <img
      class="close-img"
      src="@/assets/img/images/icon/close-icon.png"
      @click="dialogVisible = false"
    />
    <p class="p1">{{ $t("nav.user_drop.address") }}</p>

    <el-form class="mt20">
      <!-- <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('trade_ctc.search.coin_type')" prop="name">
            <el-autocomplete
              style="width: 100%"
              v-model="formData.coinType"
              :fetch-suggestions="querySearch"
              :placeholder="$t('withdrawal_address_manage.search_coin')"
              :trigger-on-focus="false"
              @select="handleSelect"
              @blur="handleBlur"
            >
              <template slot-scope="props">
                <div class="name">{{ props.item.coinName }}</div>
              </template>
            </el-autocomplete>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('tipsVal.networkType')" prop="network">
            <el-select
              v-model="formData.network"
              :placeholder="$t('tipsVal.inputPlaceholder')"
              style="width: 100%"
              :disabled="!formData.coinType"
            >
              <el-option
                v-for="value in networksList"
                :key="value"
                :label="value"
                :value="value"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row> -->
      <el-form-item :label="$t('tipsVal.networkType')" prop="network">
        <el-select
          v-model="formData.network"
          :placeholder="$t('tipsVal.inputPlaceholder')"
          style="width: 100%"
        >
          <el-option
            v-for="value in networksList"
            :key="value"
            :label="value"
            :value="value"
          />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('withdrawal_address_manage.another_name')">
        <el-input
          v-model="formData.alias"
          :placeholder="$t('tipsVal.inputPlaceholder')"
        />
      </el-form-item>
      <el-form-item :label="$t('withdrawal_address_manage.address')">
        <el-input
          v-model="formData.address"
          :placeholder="$t('tipsVal.inputPlaceholder')"
        />
      </el-form-item>
      <!-- <el-form-item>
        <el-tooltip
          effect="dark"
          :content="$t('withdrawal_address_manage.memo_tip')"
          placement="right"
        >
          <div class="c-flex-align-center text-lable">
            <p>Memo</p>
            <img
              src="@/assets/img/images/icon/icon-question.png"
              class="question-icon ml12"
            />
          </div>
        </el-tooltip>
        <el-input
          v-model="formData.memo"
          :placeholder="$t('tipsVal.inputPlaceholder')"
        />
      </el-form-item> -->
      <el-form-item
        :label="$t('withdrawal_address_manage.phone_code')"
        v-if="user.phoneSecurity === 1"
      >
        <el-input
          v-model="formData.phoneCode"
          :placeholder="$t('tipsVal.inputPlaceholder')"
        >
          <template slot="append"
            ><span v-if="!phoneCodeStatus.hasSend" @click="hasSendPhoneCode">
              {{ $t("withdrawal_address_manage.get_code") }}</span
            >
            <span v-else>{{ phoneCodeStatus.times }}</span></template
          >
        </el-input>
      </el-form-item>

      <el-form-item
        :label="$t('withdrawal_address_manage.email_code')"
        v-if="user.emailSecurity === 1"
      >
        <el-input
          v-model="formData.emailCode"
          :placeholder="$t('tipsVal.inputPlaceholder')"
        >
          <template slot="append"
            ><span v-if="!emailCodeStatus.hasSend" @click="hasSendEmailCode">
              {{ $t("withdrawal_address_manage.get_code") }}</span
            >
            <span v-else>{{ emailCodeStatus.times }}</span></template
          >
        </el-input>
      </el-form-item>
      <el-form-item
        :label="$t('withdrawal_address_manage.google_code')"
        v-if="user.googleSecurity === 1"
      >
        <el-input
          v-model="formData.googleCode"
          :placeholder="$t('tipsVal.inputPlaceholder')"
        />
      </el-form-item>
    </el-form>
    <div class="btn-box">
      <div class="btn2" @click="submit">
        {{ $t("user_center.account_setting.add") }}
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      dialogVisible: false,

      coinData: [],
      formData: {
        address: "",
        alias: "",
        coinType: "",
        emailCode: "",
        emailToken: "",
        memo: "",
        network: "",
        phoneCode: "",
        phoneToken: "",
        googleCode: "",
      },
      phoneCodeStatus: {
        hasSend: false,
        times: 60,
      },
      emailCodeStatus: {
        hasSend: false,
        times: 60,
      },
      phoneCodeStatus_withdraw: {
        hasSend: false,
        times: 60,
      },
      emailCodeStatus_withdraw: {
        hasSend: false,
        times: 60,
      },
      beforeRow: {},
      withdrawData: {
        address: "",
        phoneCode: "",
        emailCode: "",
        googleCode: "",
        memo: "",
        amount: 0,
        coinType: "",
        emailToken: "",
        password: "",
        phoneToken: "",
        realAmount: 0,
      },
      hasMemo: true,
      filterData: {
        page: 1,
        rows: 10,
      },
      total: 0,
      tableData: [],
      networksList: [],
    };
  },
  computed: {
    ...mapState({
      user: "user",
      errorCode: "errorCode",
    }),
  },
  created() {
    // if (this.user.statusKyc !== 1) {
    //   this.$alert(
    //     this.$t("user_center.need_auth"),
    //     this.$t("user_center.tip"),
    //     {
    //       confirmButtonText: this.$t("user_center.i_know"),
    //       type: "warning",
    //     },
    //   )
    //     .then(() => {
    //       this.dialogVisible = false;
    //     })
    //     .catch(() => {
    //       this.dialogVisible = false;
    //     });
    // }
    // this.getTableData();
    this.getAllCoin();
    this.handleSelect();
  },
  methods: {
    //获取充币提币文案
    // getCon(desc) {
    //   return desc.split("========================");
    // },
    // deleteAddress(row) {
    //   this.$confirm(
    //     this.$t("withdrawal_address_manage.delete_tip") + row.alias + "?",
    //     this.$t("withdrawal_address_manage.tip"),
    //     {
    //       confirmButtonText: this.$t("withdrawal_address_manage.delete_btn"),
    //       cancelButtonText: this.$t("withdrawal_address_manage.cancel"),
    //       type: "warning",
    //     },
    //   )
    //     .then(() => {
    //       this.$axios.post("/withdraw/delete", { id: row.id }).then((res) => {
    //         if (res.data.code === this.errorCode.ok) {
    //           this.$message({
    //             type: "success",
    //             message: this.$t("withdrawal_address_manage.delete_success"),
    //           });
    //           this.getTableData();
    //         } else {
    //           this.$message.error(res.data.msg);
    //         }
    //       });
    //     })
    //     .catch(() => {});
    // },
    querySearch(queryString, callback) {
      let restaurants = this.coinData;
      let results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      console.log(results);
      // 调用 callback 返回建议列表的数据
      callback(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.coinName
            .toLowerCase()
            .indexOf(queryString.toLowerCase()) >= 0
        );
      };
    },
    handleSelect(item) {
      // this.hasMemo = item.memo === 'memo';
      // this.formData.coinType = item.coinName;
      this.$axios
        .post("/Coin/getSupportedNetworks", {
          coinType: "",
          network: "",
        })
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            // this.networksList = ['ETH'];
            this.networksList = res.data.networks;
            if (this.networksList && this.networksList.length > 0) {
              this.formData.network = this.networksList[0];
            }
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
    },
    handleBlur(ev) {
      //console.log(ev)
    },
    //是否开启了2种及以上的验证
    judgeValidateNum() {
      let sum = 0;
      if (this.user.phoneSecurity === 1) {
        sum++;
      }
      if (this.user.emailSecurity === 1) {
        sum++;
      }
      if (this.user.googleSecurity === 1) {
        sum++;
      }
      if (sum >= 2) {
        return true;
      } else {
        this.$message({
          type: "warning",
          message: this.$t("user_assets.validate_warning"),
        });
        return false;
      }
    },
    openExpand(row) {
      if (row.canWithdraw === -1) {
        //禁止提币
        this.$message({
          type: "error",
          message: this.$t("user_assets.can_not_withdraw"),
        });
        return false;
      }
      if (!this.judgeValidateNum()) {
        return false;
      }
      if (this.user.tranPassword === -1) {
        this.$confirm(
          this.$t("partner.need_set_password"),
          this.$t("user_center.tip"),
          {
            confirmButtonText: this.$t("partner.set_now"),
            cancelButtonText: this.$t("partner.cancel"),
            type: "warning",
          },
        )
          .then(() => {
            this.$router.push({ path: "/userCenter/setTradePassword" });
          })
          .catch(() => {});
      } else {
        if (this.beforeRow) {
          this.$refs.address_table.toggleRowExpansion(this.beforeRow, false); //收起之前的展开行
          this.withdrawRest();
        }
        this.withdrawData.coinType = row.coinType;
        this.withdrawData.address = row.address;
        this.$refs.address_table.toggleRowExpansion(row, true);
        this.beforeRow = row;
      }
    },
    closeExpand() {
      if (this.beforeRow) {
        this.$refs.address_table.toggleRowExpansion(this.beforeRow, false); //收起之前的展开行
      }
    },
    //初始化提现参数
    withdrawRest() {
      let emailToken = this.withdrawData.emailToken;
      let phoneToken = this.withdrawData.phoneToken;
      let address = this.withdrawData.address;
      let coinType = this.withdrawData.coinType;
      //若用户连续提币，需要保留以上参数
      this.withdrawData = {
        address: address, //保留地址
        phoneCode: "",
        emailCode: "",
        memo: "",
        amount: 0,
        coinType: coinType, //保留coinType
        emailToken: emailToken, //保留emailToken
        password: "",
        phoneToken: phoneToken, //保留phoneToken
        realAmount: 0,
      };
    },
    //实际到账
    getActual(fee, available) {
      if (fee + this.withdrawData.amount > available) {
        this.withdrawData.realAmount = this.withdrawData.amount - fee;
        return this.withdrawData.amount - fee > 0
          ? this.withdrawData.amount - fee
          : 0;
      } else {
        this.withdrawData.realAmount = this.withdrawData.amount;
        return this.withdrawData.amount;
      }
    },
    withdrawAmountChange(withdrawObj) {
      if (this.withdrawData.amount > withdrawObj.balanceAvailable) {
        this.withdrawData.amount = withdrawObj.balanceAvailable;
      } else if (this.withdrawData.amount < withdrawObj.minAmount) {
        this.withdrawData.amount = withdrawObj.minAmount;
      }
      this.withdrawData.amount = this.getFloorNum(
        this.withdrawData.amount,
        withdrawObj.scale,
      );
    },
    //提现
    doWithdraw(row) {
      this.$axios
        .post("/userAssets/withdraw", this.withdrawData)
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.$message({
              type: "success",
              message: this.$t("user_assets.withdraw_success"),
            });
            //刷新可提币数量
            this.$axios
              .post("/userAssets/getWithdrawParam", { coinType: row.coinType })
              .then((res) => {
                row.withdrawObj = res.data.data;
              });
            this.withdrawRest();
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
    },
    submit() {
      if (!this.addValidate().valid) {
        this.$message.error(this.addValidate().msg);
        return false;
      }
      if (!this.judgeValidateNum()) {
        return false;
      }
      this.$axios.post("/withdraw/add", this.formData).then((res) => {
        if (res.data.code === this.errorCode.ok) {
          this.$message({
            type: "success",
            message: this.$t("withdrawal_address_manage.add_success"),
          });
          this.formData = {
            address: "",
            alias: "",
            coinType: "",
            emailCode: "",
            emailToken: "",
            memo: "",
            network: "",
            phoneCode: "",
            phoneToken: "",
          }; //数据置空
          this.phoneCodeStatus.times = this.emailCodeStatus.times = 0; //发送验证码按钮读秒置0使其走完
          this.$emit("submitBack");
          this.getTableData();
        } else {
          this.$message.error(res.data.msg);
        }
        this.dialogVisible = false;
      });
    },
    addValidate() {
      // let coinFlag = false;
      // this.coinData.forEach((value) => {
      //   if (value.coinName === this.formData.coinType) {
      //     coinFlag = true;
      //     return;
      //   }
      // });
      // if (!coinFlag) {
      //   return {
      //     valid: false,
      //     msg: this.$t("validate.coin_type_error"),
      //   };
      // }
      if (this.formData.alias === "") {
        return {
          valid: false,
          msg: this.$t("validate.alias_require"),
        };
      }
      if (
        this.user.phoneSecurity === 1 &&
        this.formData.phoneCode.trim() === ""
      ) {
        return {
          valid: false,
          msg: this.$t("validate.mes_code_require"),
        };
      }
      if (
        this.user.emailSecurity === 1 &&
        this.formData.emailCode.trim() === ""
      ) {
        return {
          valid: false,
          msg: this.$t("validate.email_code_require"),
        };
      }
      if (
        this.user.googleSecurity === 1 &&
        this.formData.googleCode.trim() === ""
      ) {
        return {
          valid: false,
          msg: this.$t("validate.google_code_require"),
        };
      }
      return {
        valid: true,
      };
    },
    getTableData() {
      this.$axios.post("/withdraw/query", this.filterData).then((res) => {
        if (res.data.code === this.errorCode.ok) {
          this.tableData = res.data.data.rows;
          this.total = res.data.data.total;
          let that = this;
          this.tableData.forEach((value, index) => {
            that.$axios
              .post("/userAssets/getWithdrawParam", {
                coinType: value.coinType,
              })
              .then((res) => {
                that.$set(that.tableData[index], "withdrawObj", res.data.data);
              });
          });
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      });
    },
    getAllCoin() {
      this.$axios.post("/withdraw/getAllCoin", {}).then((res) => {
        if (res.data.code === this.errorCode.ok) {
          this.coinData = res.data.data;
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      });
    },
    hasSendPhoneCode() {
      this.phoneCodeStatus.hasSend = true;
      let timer = setInterval(() => {
        if (this.phoneCodeStatus.times <= 0) {
          this.phoneCodeStatus.hasSend = false;
          this.phoneCodeStatus.times = 60;
          clearInterval(timer);
        } else {
          this.phoneCodeStatus.times--;
        }
      }, 1000);
      this.$axios
        .post("/sendCode/send", {
          verifyType: "phone",
          serviceName: "withdrawAdd",
        })
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.formData.phoneToken = res.data.data.token;
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
    },
    hasSendEmailCode() {
      this.emailCodeStatus.hasSend = true;
      let timer = setInterval(() => {
        if (this.emailCodeStatus.times <= 0) {
          this.emailCodeStatus.hasSend = false;
          this.emailCodeStatus.times = 60;
          clearInterval(timer);
        } else {
          this.emailCodeStatus.times--;
        }
      }, 1000);
      this.$axios
        .post("/sendCode/send", {
          verifyType: "email",
          serviceName: "withdrawAdd",
        })
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.formData.emailToken = res.data.data.token;
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
    },
    hasSendPhoneCode_withdraw() {
      if (this.user.phoneVerify === -1) {
        this.$confirm(
          this.$t("user_center.need_bind"),
          this.$t("user_center.tip"),
          {
            confirmButtonText: this.$t("user_center.bind_now"),
            cancelButtonText: this.$t("user_center.cancel"),
            type: "warning",
          },
        )
          .then(() => {
            this.$router.push({ path: "/userCenter/phoneBind" });
          })
          .catch(() => {});
        return false;
      }
      this.phoneCodeStatus_withdraw.hasSend = true;
      let timer = setInterval(() => {
        if (this.phoneCodeStatus_withdraw.times <= 0) {
          this.phoneCodeStatus_withdraw.hasSend = false;
          this.phoneCodeStatus_withdraw.times = 60;
          clearInterval(timer);
        } else {
          this.phoneCodeStatus_withdraw.times--;
        }
      }, 1000);
      this.$axios
        .post("/sendCode/send", {
          verifyType: "phone",
          serviceName: "withdraw",
        })
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.withdrawData.phoneToken = res.data.data.token;
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
    },
    dialogClose() {
      this.formData = {
        address: "",
        alias: "",
        coinType: "",
        emailCode: "",
        emailToken: "",
        memo: "",
        network: "",
        phoneCode: "",
        phoneToken: "",
        googleCode: "",
      };
    },
    hasSendEmailCode_withdraw() {
      if (this.user.emailVerify === -1) {
        this.$confirm(
          this.$t("user_center.need_bind"),
          this.$t("user_center.tip"),
          {
            confirmButtonText: this.$t("user_center.bind_now"),
            cancelButtonText: this.$t("user_center.cancel"),
            type: "warning",
          },
        )
          .then(() => {
            this.$router.push({ path: "/userCenter/emailBind" });
          })
          .catch(() => {});
        return false;
      }
      this.emailCodeStatus_withdraw.hasSend = true;
      let timer = setInterval(() => {
        if (this.emailCodeStatus_withdraw.times <= 0) {
          this.emailCodeStatus_withdraw.hasSend = false;
          this.emailCodeStatus_withdraw.times = 60;
          clearInterval(timer);
        } else {
          this.emailCodeStatus_withdraw.times--;
        }
      }, 1000);
      this.$axios
        .post("/sendCode/send", {
          verifyType: "email",
          serviceName: "withdraw",
        })
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.withdrawData.emailToken = res.data.data.token;
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-dialog {
  width: 920px;
  background: #ffffff;
  border-radius: 10px 10px 10px 10px;
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 32px 30px;
  }
  .el-form-item__label {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
  }
  .el-input-group__append {
    border: none;
    background: rgba(214, 216, 219, 0.3);
    font-family: PingFang SC, PingFang SC;
    font-weight: 800;
    font-size: 16px;
    color: #333333;
  }
  .el-form-item {
    margin-bottom: 8px;
  }
  .el-input__inner {
    border-radius: 8px 8px 8px 8px;
  }
  .el-input-group--append {
    gap: 16px;
    display: flex;
  }
  .el-input-group__append {
    cursor: pointer;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid var(--primary-color);
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: var(--primary-color);
    padding: 0 24px;
    width: auto;
    display: flex;
    align-items: center;
  }
}
.mt8 {
  margin-top: 8px;
}
.p1 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 800;
  font-size: 36px;
  color: #333333;
}
.p2 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #333333;
}
.p3 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #999999;
}
.sp1 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 20px;
  color: #333333;
}
.sp2 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 800;
  font-size: 32px;
  color: var(--primary-color);
}
.box1 {
  width: 480px;
  height: 160px;
  overflow: hidden;
  padding-left: 20px;
  background: #ffffff;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 12px 12px 12px 12px;
  background-image: url(~@/assets/img/images/member-bj.png);
}
.close-img {
  width: 14px;
  height: 14px;
  top: 20px;
  right: 20px;
  cursor: pointer;
  position: absolute;
}
.btn-box {
  gap: 10px;
  display: flex;
  margin-top: 32px;
  .btn1 {
    flex: 1;
    cursor: pointer;
    height: 48px;
    line-height: 48px;
    text-align: center;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid var(--primary-color);
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: var(--primary-color);
  }
  .btn2 {
    flex: 1;
    height: 48px;
    cursor: pointer;
    line-height: 48px;
    text-align: center;
    background: var(--primary-color);
    border-radius: 8px 8px 8px 8px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: var(--white-color);
  }
}
.question-icon {
  width: 18px;
  height: 18px;
  cursor: pointer;
}
.text-lable {
  width: fit-content;
}
</style>
